import createFormatter from './use-intl.esm3.js';

/** @deprecated Switch to `createFormatter` */

function createIntl() {
  var formatter = createFormatter.apply(void 0, arguments);
  return {
    formatDateTime: formatter.dateTime,
    formatNumber: formatter.number,
    formatRelativeTime: formatter.relativeTime
  };
}

export { createIntl as default };
//# sourceMappingURL=use-intl.esm4.js.map
